import { Task, TaskCategory, DocumentType } from '@admiin-com/ds-graphql';
import { WBFlex } from '@admiin-com/ds-web';
import { TextFormField } from '../../../../components/TextFormField/TextFormField';
import { getTaskType, getTaskAmount } from '../../../../helpers/tasks';
import { useTaskFromToName } from '../../../../hooks/useTaskToName/useTaskToName';
import { AmountInfo } from './AmountInfo';
import {
  frontDateFromBackendDate,
  numberToCurrency,
} from '@admiin-com/ds-common';
import { useTranslation } from 'react-i18next';
export const TaskDetailForm = ({ task }: { task: Task }) => {
  const { fromName, toName } = useTaskFromToName(task);
  const { t } = useTranslation();
  const isTax = task.category === TaskCategory.TAX;

  return (
    <WBFlex flexDirection={'column'} gap={1.5}>
      <TextFormField label="From" value={fromName || ''} />
      {toName && <TextFormField label="To" value={toName || ''} />}
      {isTax &&
        task.documentType &&
        task.documentType !== DocumentType.NONE && (
          <TextFormField
            label={t('documentType', { ns: 'taskbox' })}
            value={task.documentType}
          />
        )}
      {isTax && task.reference && (
        <TextFormField
          label={t('lodgementReference', { ns: 'taskbox' })}
          value={task.reference}
        />
      )}
      <TextFormField
        label={
          isTax
            ? t('lodgementAt', { ns: 'taskbox' })
            : t('dueAt', { ns: 'taskbox' })
        }
        value={frontDateFromBackendDate(
          isTax && task.lodgementAt ? task.lodgementAt : task.dueAt
        )}
      />
      {isTax && task.settlementStatus && (
        <TextFormField
          label={t('settlementStatus', { ns: 'taskbox' })}
          value={t(task.settlementStatus, { ns: 'taskbox' })}
        />
      )}
      {isTax && getTaskAmount(task) !== 0 && (
        <TextFormField
          label={t('taxAmount', { ns: 'taskbox' })}
          value={numberToCurrency(getTaskAmount(task))}
        />
      )}
      {getTaskType(task) !== 'DOCUMENT' && !isTax && <AmountInfo task={task} />}
      <TextFormField
        multiline
        label="Comments (Optional)"
        value={task.notes || 'N/A'}
      />
    </WBFlex>
  );
};
